<template>
	<slot
		:value="value"
		:meta="meta"
		:errors="errors"
		:error-message="errorMessage"
		:handle-blur="customHandleBlur"
		:handle-input="customHandleChange"
	></slot>
</template>

<script setup>
import { computed } from 'vue'
import { useField } from 'vee-validate';
import * as yup from 'yup';

const props = defineProps({
	name: String,
	validatorString: String
});

// Create validator function from string
const validator = computed(() => {
    return new Function('yup', `return ${props.validatorString}`)(yup);
});

const { value, meta, errors, handleBlur, handleChange } = useField(() => props.name, validator);

const customHandleBlur = (e) => {
	handleBlur(e, meta.dirty);
}

const customHandleChange = (e) => {
	handleChange(e, errors.value.length > 0);
}

const errorMessage = computed(() => {
	return errors.value.length > 0 ? errors.value.map(sentence => sentence.charAt(0).toUpperCase() + sentence.slice(1)).join('. ') + '.' : '';
});
</script>
